import contactInformation from '@/shared/config/contactInformation';
import { useTranslation } from 'react-i18next';

export const footerItemGroups = ['company'];

export const useFooterItems = () => {
  const { t } = useTranslation();

  return {
    company: [
      {
        url: contactInformation.accountManagement.url,
        title: t('footer.contact')
      },
      {
        url: contactInformation.sales.url,
        title: t('footer.cooperation_request')
      },
      {
        url: '/whistleblower-system',
        title: t('footer.whistleblower_system')
      },
      {
        url: t('footer.sustainability_indicators.link'),
        title: t('footer.sustainability_indicators')
      },
      {
        url: '/privacy-policies',
        title: t('footer.dataPrivacy')
      },
      {
        url: '/imprint',
        title: t('footer.imprint')
      }
    ]
  };
};
